export const SMALL = 24;
export const DEFAULT = 28;
export const LARGE = 36;
